// @flow
import React from 'react';
import glamorous from 'glamorous';
import { isURL } from 'validator';
import LabelValue from './LabelValue';

type Props = {
  credentialInfo?: Array<Object>,
  pin?: string,
  voucherCode?: string,
};

const defaultProps = {
  credentialInfo: undefined,
  pin: undefined,
  voucherCode: undefined,
};

const VoucherCodeSpan = glamorous.span({
  wordBreak: 'break-all',
  ' a': {
    color: '#5bc0de',
    textDecoration: 'underline',
  },
});

function DetailsList({ credentialInfo, voucherCode, pin }: Props) {
  return (
    <div>
      {credentialInfo ? (
        credentialInfo.map(({ label, value }) => value !== null && <LabelValue label={label}>{value}</LabelValue>)
      ) : (
        <div>
          {voucherCode && (
            <LabelValue label="Voucher Code">
              <VoucherCodeSpan>
                {isURL(voucherCode) ? (
                  <a href={voucherCode} rel="noopener noreferrer" target="_blank">
                    {voucherCode}
                  </a>
                ) : (
                  <span>{voucherCode}</span>
                )}
              </VoucherCodeSpan>
            </LabelValue>
          )}
          {pin && <LabelValue label="PIN">{pin}</LabelValue>}
        </div>
      )}
    </div>
  );
}

DetailsList.defaultProps = defaultProps;

export default DetailsList;
